// extracted by mini-css-extract-plugin
module.exports = {"backButton":"_1GAfigoktbZM9kWlZ4pzDC"};